import { Grid } from '@material-ui/core';

// local imports
import { useInputChangeHandler } from 'app/hooks';
import { AsyncButton, FormInput, MaskedInput, FormBasicSelect, PasswordInput } from '../../atoms';

const PharmacyUserForm = ({ isEdit, loading, handleDelete, deleteLoading, roles }) => {
  const { values, preventNonSpecialCharsInput, handlePhoneInput } = useInputChangeHandler();
  const btnText = isEdit ? 'Kullanıcıyı Güncelle' : 'Kullanıcı Ekle';
  const btnIcon = isEdit ? 'update' : 'person_add';
  const gridItemProps = {
    xs: 12,
    sm: 6,
    ...(!isEdit && { lg: 4, xl: 3 })
  };

  return (
    <div className="flex justify-center items-center">
      {/* Personal Info */}
      <Grid container spacing={2} xs={12}>
        <Grid item {...gridItemProps}>
          <FormInput
            id="pharmacy_user_name"
            label="Ad Soyad"
            name="full_name"
            placeholder="Ad soyad"
            disabled={loading}
            value={values?.full_name || ''}
            onChange={preventNonSpecialCharsInput}
            maxLength={50}
          />
        </Grid>

        <Grid item {...gridItemProps}>
          <MaskedInput
            disabled={loading}
            type="text"
            mask="+\90 \(999\) 999 99 99"
            maskChar="_"
            alwaysShowMask
            id="id_telephone"
            name="telephone"
            placeholder="Cep Telefonu"
            label="Cep Telefonu"
            value={values?.telephone || ''}
            onChange={handlePhoneInput}
          />
        </Grid>

        <Grid item {...gridItemProps}>
          <FormInput
            id="pharmacy_user_email"
            label="E-Posta Adresi"
            name="email"
            placeholder="E-Posta Adresi"
            value={values?.email || ''}
            disabled={loading}
            maxLength={100}
          />
        </Grid>

        <Grid item {...gridItemProps}>
          <FormBasicSelect
            id="pharmacy_user_role"
            name="role_id"
            label="Yetki"
            value={values?.role_id}
            options={roles || []}
            disabled={loading}
          />
        </Grid>

        {/* Password */}
        {!isEdit && (
          <>
            <Grid item xs={12} sm={6} lg={4} xl={3}>
              <PasswordInput
                id="password_id"
                name="password"
                label="Parola"
                placeholder="Parola"
                disabled={loading}
                maxLength={12}
              />
            </Grid>

            <Grid item xs={12} sm={6} lg={4} xl={3}>
              <PasswordInput
                id="password_confirmation_id"
                name="password_confirmation"
                label="Parola Onay"
                placeholder="Parola onay"
                disabled={loading}
                maxLength={12}
              />
            </Grid>
          </>
        )}

        {/* Action buttons */}
        <Grid item xs={12} className="flex flex-wrap justify-end">
          {isEdit && (
            <AsyncButton
              disabled={loading || deleteLoading}
              icon="delete"
              text="Kullanıcıyı Sil"
              type="button"
              loading={deleteLoading}
              handleClick={handleDelete}
              className="bg-red-400 text-white hover:bg-red-600 mr-16"
            />
          )}

          <AsyncButton
            icon={btnIcon}
            text={btnText}
            disabled={deleteLoading}
            loading={loading}
            className="bg-green-400 text-white hover:bg-green-600"
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default PharmacyUserForm;
